export default {
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: `${process.env.VUE_APP_AWS_COGNITO_IDENTITY_POOL_ID}`,

    // REQUIRED - Amazon Cognito Region
    region: `${process.env.VUE_APP_AWS_COGNITO_REGION}`,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: `${process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID}`,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: `${process.env.VUE_APP_AWS_COGNITO_APP_CLIENT_ID}`,
  },
};
